export enum MaritalStatus {
    SINGLE = 'SINGLE',
    MARRIED = 'MARRIED',
    SEPARATED = 'SEPARATED',
    HOUSEHOLD_HEAD = 'HOUSEHOLD_HEAD',
    WIDOWED = 'WIDOWED',
    NOT_SURE = 'NOT_SURE'
}